import {Component} from '@angular/core';

@Component({
  selector: 'cm-publisher-request-success',
  template: `
    <div>
      <cm-topbar title="Ad tags"></cm-topbar>
      <div class="main-content">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <mat-card class="text-center">
                <mat-card-title>
                  <i class="fas fa-check fa-2x text-success"></i>
                </mat-card-title>
                <mat-card-content>
                  <h4 class="mt40 mb20">Your request has been sent successfully and will be processed shortly.</h4></mat-card-content>
                </mat-card>
              <div class="mat-card-outer-controls d-flex justify-content-between">
                <button mat-raised-button color="primary" routerLink="/products" class="large">OK</button>
                <button mat-raised-button color="primary" routerLink="/inventory/ad-tags/requested" class="large">Go to my request list</button>
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>

  `,
})
export class PublisherRequestSuccessComponent {

}
